// @ts-nocheck
import { Badge } from "@corpuscomplete/web-ui/components/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@corpuscomplete/web-ui/components/card";
import { Text } from "@corpuscomplete/web-ui/components/text";
import { TemporalHelpers } from "@corpuscomplete/core/common/date-time";
import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { cn } from "@corpuscomplete/web-ui/lib/utils";

export function PlannedMealCard({
  entry,
  onSelect,
  selected = false,
}: {
  entry: PlannedMealCalendar.CalendarEntry;
  onSelect: () => void;
  selected?: boolean;
}) {
  const meal = entry.instance.plannedMeal;
  const label = meal.name.trim() || "Unnamed planned meal";
  const memberCount = meal.plates.length;
  const timeLabel = TemporalHelpers.formatTime(
    entry.effectiveTimeAt.toZonedDateTimeISO(entry.instance.timeZone).toPlainTime(),
  );

  return (
    <button type="button" className="h-full text-left outline-none" onClick={onSelect}>
      <Card
        size="sm"
        className={cn(
          "h-full cursor-pointer gap-2 transition-shadow hover:ring-primary/30",
          selected && "border-primary bg-muted ring-1 ring-primary/30",
        )}
      >
        <CardHeader className="gap-2">
          <CardTitle className={meal.name.trim() ? undefined : "text-muted-foreground italic"}>
            {label}
          </CardTitle>
          <div className="flex flex-wrap gap-1">
            <Badge variant={meal.status === "published" ? "default" : "outline"}>
              {meal.status}
            </Badge>
            <Badge variant="secondary">{meal.typeLabel}</Badge>
            <Badge variant="outline">Event</Badge>
          </div>
        </CardHeader>
        <CardContent className="flex flex-col gap-1">
          <Text variant="xs" className="text-muted-foreground">
            {timeLabel}
          </Text>
          <Text variant="xs" className="text-muted-foreground">
            {entry.currentUserItemCount} items, {entry.currentUserDescriptorCount} descriptors
          </Text>
          <Text variant="xs" className="text-muted-foreground">
            {entry.assignmentCount} assignment{entry.assignmentCount === 1 ? "" : "s"}
          </Text>
          {memberCount > 1 && (
            <div className="flex flex-wrap gap-1" aria-label={`${memberCount} meal members`}>
              {meal.plates.map((plate, index) => (
                <Badge key={plate.id} variant="outline" title={plate.userId}>
                  {plate.userId === entry.visiblePlate?.userId ? "You" : `Member ${index + 1}`}
                </Badge>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </button>
  );
}
